export const WindowType = {
  Standard: 'standard',
  Panoramic: 'panoramic',
};
